import { KalturaMetaArgs, KalturaStringValue } from '@kaltura-ott/ott-client-types/api/types';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import { META_ENUMERATION_TYPE } from '../utils/constants';

import { InitialMetaConst } from './config';
import { createMeta } from './metas';
import { createMetaTag } from './tags';
import { stringToTranslationToken } from './utils';

/**
 * Creates Basic Metas
 *
 * @param initialMetas - Metas from config/metas
 * @param language - default group language
 */
export const createInitialMetas = (
  initialMetas: { [key: string]: InitialMetaConst },
  language = 'eng',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Observable<any> => {
  const systemNames = Object.keys(initialMetas);

  const requests = systemNames.map((systemName) => {
    const _m = initialMetas[systemName];
    const meta: KalturaMetaArgs = {
      systemName,
      multilingualName: [stringToTranslationToken(_m.name, language)],
      dataType: _m.dataType,
      multipleValue: _m.multipleValue,
      features: _m.features.join(','),
      helpText: _m.helpText,
      isProtected: _m.isProtected,
    };
    if (_m.dynamicData) {
      meta.dynamicData = {};
      const dynamicKeys = Object.keys(_m.dynamicData);
      dynamicKeys.forEach((key) => {
        // @ts-expect-error TODO Fix
        meta.dynamicData[key] = new KalturaStringValue({ value: _m.dynamicData?.key?.toString() });
      });
    }

    return createMeta(meta).pipe(
      catchError((err) => {
        return of(err);
      }),
      mergeMap((meta) => {
        if (_m.features.indexOf(META_ENUMERATION_TYPE) > -1 || _m.features.indexOf(META_ENUMERATION_TYPE) > -1) {
          // @ts-expect-error TODO Fix
          return forkJoin(..._m.tags.map((tag) => createMetaTag({ tag, metaId: parseInt(meta.id) }, language)));
        } else {
          return of('emty');
        }
      }),
    );
  });

  return forkJoin(requests);
};
